import React, { useState, useRef } from "react";
import { Grid, IconButton, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import SimpleDialog from "../../../SimpleDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import Filter from "../../../Filter";

const NoHeaderDataGrid = styled(DataGrid)(({ }) => ({ "& .MuiDataGrid-columnHeaders": { display: "none" }, "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" } }));

const AirportTab = ({ centerAirports, setCenterAirports, admin }) => {

    const [airportDialogOpen, setAirportDialogOpen] = useState(false);
    const [newAirportValue, setNewAirportValue] = useState(0);

    const [filter, setFilter] = useState("");
    const [activeFilter, setActiveFilter] = useState(true);

    const searchBarHelper = "Search for an airport...";

    const updateActiveFilter = (e) => {
        setActiveFilter(e.target.checked);
    }

    const HandleFilter = (e) => {
        setFilter(e.toLowerCase());
    };

    function filterAirports(airport) {
        return airport.name.toLowerCase().includes(filter);
    }

    const centerAirportsCols = [
        { field: 'name', headerName: 'Name', flex: 1 },
        {
            field: 'actions',
            type: 'actions',
            sortable: false,
            getActions: (params) => {
                return [
                <>
                {admin &&
                <GridActionsCellItem icon={params.id > 0 ? <DeleteIcon /> : <></>} onClick={() => deleteAirport(params)} />
                }
                </>
            ]
            }
        }
    ]

    const deleteAirport = (params) => {
        if (params.id > 0) {
            setCenterAirports(centerAirports.filter((a) => a.id != params.id));
        }
    };

    const handleNewAirportDialogClickOpen = () => {
        setAirportDialogOpen(true);
    };

    const handleNewAirportDialogClickClose = (value) => {
        if (value.id > 0 && !centerAirports.some(({ id }) => id === value.id)) {
            setCenterAirports([...centerAirports, value])
            setNewAirportValue(value);
        }
        setAirportDialogOpen(false);
    };

    return (

        <>
            <Grid item xs={12} container sx={{ height: 350 }}>
                <div style={{ height: 350, width: '100%' }}>
                    <Grid item container >
                        <Filter
                            setSearchQuery={HandleFilter}
                            searchQuery={filter}
                            helper={searchBarHelper}
                            setActive={updateActiveFilter}
                            addDataFunction={() => handleNewAirportDialogClickOpen()}
                            HideAddButton={!admin}
                        />
                    </Grid>
                    {centerAirports ?
                        <NoHeaderDataGrid
                            rows={centerAirports.filter(filterAirports).map((airport => {
                                return airport;
                            }))}
                            columns={centerAirportsCols}
                            disableSelectionOnClick
                            hideFooter
                            rowsPerPageOptions={[]} />
                        : <></>}
                </div>

                <SimpleDialog
                    selectedValue={newAirportValue}
                    open={airportDialogOpen}
                    onClose={handleNewAirportDialogClickClose}
                />
            </Grid>
        </>
    )

}

export default AirportTab;